import axios from 'axios'

export default axios.create({
    baseURL : "https://complexapi.porichorja.org/api"
})